export default {
  title: '{jobName}的推荐设置',
  symbols: {
    cash: '￥',
    point: '积分'
  },
  label: {
    hireNumber: '雇佣人数',
    everyHireCost: '每个人奖励',
    onlyEmployeeReferral: '非员工有资格获得奖励',
    hireStepCost: '雇佣阶段奖励',
    hireStep: {
      probation: '通过试用期',
      onboard: '入职报到',
      interview: '参加面试',
      apply: '职位申请'
    },
    referrer: {
      root: '初始推荐人',
      middle: '间接推荐人',
      direct: '直接推荐人'
    },
    hireType: {
      employee: '员工',
      notEmployee: '非员工'
    },
    referralType: {
      cash: '现金',
      point: '积分',
      payroll: '工资'
    },
    configStatus: {
      draft: '草稿',
      pending: '待定',
      approved: '已审核',
      rejected: '已拒绝',
      archived: '存档'
    },
    configStatusActionName: {
      pending: '提交',
      approved: '批准',
      rejected: '拒绝',
      archived: '存档'
    },
    planCost: '计划预算',
    actualCost: '实际预算',
    postpaid: '后付',
    prepay: '预付',
    chainTip: {
      job: '职位',
      candidate: '候选人',
      root: {
        line1: '初始',
        line2: '推荐人'
      },
      middle: {
        line1: '间接',
        line2: '推荐人'
      },
      direct: {
        line1: '直接',
        line2: '推荐人'
      }
    }
  },
  btn: {
    save: '提交批准',
    saveDraft: '保存草稿',
    backJobList: '< 返回职位列表'
  },
  message: {
    referralTip: {
      everyHireCost: '请注意，根据中华人民共和国的税法，每笔推荐人的支付金额，菁客将扣除和支付20%的预扣税，用于缴纳相应税款。',
      hireStep: {
        probation: '勾选此项，推荐人在其推荐的候选人通过试用期后获得奖励。',
        onboard: '勾选此项，推荐人在其推荐的候选人入职后获得奖励。',
        interview: '勾选此项，推荐人在其推荐的候选人参加面试后获得奖励。在下方的空格中，输入您计划奖励的面试上限数。例如，在空格内输入“10”，表示前10个参加面试的候选人所对应的推荐人将获得奖励。',
        apply: '勾选此项，推荐人在其推荐的候选人申请职位后获得奖励。在下方的空格中，输入您计划奖励的申请上限数。 例如，在空格内输入“10”，表示前10个申请职位的候选人所对应的推荐人将获得奖励。'
      },
      postpaid: '“后付”指在被推荐人入职或者通过试用期后给到推荐人的奖励。此处显示奖励数为所有被推荐的候选人成功完成推荐环节后企业所需要支付的最高预算总数。在开放一个职位之前，您没有必要预充所有后付预算。但是，在存档已经完成所有推荐环节的职位前，后付奖励须支付给所有符合要求的推荐人。<br/><br/>根据中华人民共和国的税法，每笔推荐人的支付金额，菁客将扣除和支付20%的预扣税，用于缴纳相应税款。',
      prepay: '“预付”指在被推荐人递交申请和完成面试后给到推荐人的奖励。您需要在职位开放前将奖励预付到您的账户中。“已申请”奖励将在被推荐的候选人投递申请后自动支付给对应的推荐人；“已面试”奖励将在被推荐的候选人完成面试后自动支付给对应的推荐人。<br/><br/>根据中华人民共和国的税法，每笔推荐人的支付金额，菁客将扣除和支付20%的预扣税，用于缴纳相应税款。'
    },
    hireNumberTooSmall: '雇佣人数不能为0',
    everyHireCostTooSmall: '每个人奖励金额需大于(或等于)100',
    stepCostHasError: '请检查奖励金额设置',
    actualCostTooSmall: '请确保实际预算大于0',
    stepCostToolSmall: '最小奖励金额不得低于2',
    stepActualCostMoreThanPlan: '总奖励不能超过预算, 如果想调高某一阶段奖励，请先减少另一阶段奖励',
    referralChainTip: {
      root: {
        name: '“初始推荐人”',
        info: '是指每个转发链上的第一个推荐者。'
      },
      middle: {
        name: '“间接推荐人”',
        info: '指推荐链上除初始推荐人和直接推荐人以外的其他推荐人。如果间接推荐人的人数少于设定奖励的人数， 推荐奖励将分配到初始推荐人奖励中。'
      },
      direct: {
        name: '“直接推荐人”',
        info: '指那些在所勾选的环节中成功通过的候选人所对应的最终推荐人。'
      }
    },
    needInputNumber: '请输入正确的数字！',
    inputNumberMustBigger: '请输入大于{number}的数字！',
    inputNumberMustSmaller: '请输入小于{number}的数字！'
  }
}
